module.exports = __webpack_public_path__ + "img/hand-left-top.02a87e1f.png";